const emptyWrapper = wrapper => {
  if (wrapper.firstChild) {
    while (wrapper.firstChild) {
      wrapper.removeChild(wrapper.firstChild)
    }
  }
}

export default emptyWrapper
